import React from "react"
import { Box } from "@mui/material"

import { AppButtonIcon, AppButtonLoading } from "@components"
import { useUserSettingsProvider } from "../../../../@hooks"


export default function actionsColumn() {
	return {
		name: "id", label: "Actions",
		options: {
			filter: false,
			customBodyRowRenderLite: (_, rowData) => <ActionsCell rowData={rowData} />
		}
	}
}

function ActionsCell({ rowData }) {
	const { isLoading, isClicked, handleSetProviderFormData, handleDeleteProvider } = useUserSettingsProvider(rowData)

	if (isLoading) return <AppButtonLoading />

	return <Box className={isClicked ? "clicked-details" : ""} sx={{  display: 'flex', justifyContent: 'center'  }}>
		<AppButtonIcon
			icon="pen"
			tooltip="Edit"
			onClick={handleSetProviderFormData}
		/>
		<AppButtonIcon
			icon="trash-can"
			tooltip="Delete"
			onClick={handleDeleteProvider}
		/>
	</Box>
}